const PROSUB_QUERY_KEYS = ["prosub_id", "prosub_ID", "Prosub_ID", "Prosub_id"] as const;

function firstNonEmptyString(value: unknown): string | undefined {
  if (value == null || value === "") {
    return undefined;
  }
  if (Array.isArray(value)) {
    return firstNonEmptyString(value[0]);
  }
  const text = String(value).trim();
  return text || undefined;
}

export function resolveProsubId(params?: Record<string, unknown> | null): string | undefined {
  if (!params) {
    return undefined;
  }

  for (const key of PROSUB_QUERY_KEYS) {
    const value = firstNonEmptyString(params[key]);
    if (value) {
      return value;
    }
  }

  for (const key of Object.keys(params)) {
    if (key.toLowerCase() === "prosub_id") {
      const value = firstNonEmptyString(params[key]);
      if (value) {
        return value;
      }
    }
  }

  return undefined;
}

export function canonicalizeProsubQueryParams<T extends Record<string, unknown>>(
  params: T
): T & { prosub_id?: string } {
  const next = { ...params } as T & { prosub_id?: string };
  const prosubId = resolveProsubId(next);

  for (const key of Object.keys(next)) {
    if (key.toLowerCase() === "prosub_id") {
      delete next[key];
    }
  }

  if (prosubId) {
    next.prosub_id = prosubId;
  }

  return next;
}

export function resolveProsubIdFromParamMap(
  paramMap?: { keys?: readonly string[]; get?: (name: string) => string | null } | null
): string | null {
  if (!paramMap?.get) {
    return null;
  }

  const params: Record<string, unknown> = {};
  const keys = new Set([...(paramMap.keys ?? []), ...PROSUB_QUERY_KEYS]);
  for (const key of keys) {
    params[key] = paramMap.get(key);
  }

  return resolveProsubId(params) ?? null;
}
